
import React from 'react'
import { mdx } from '@mdx-js/react'

/* @jsxRuntime classic */
/* @jsx mdx */
import { Playground, Props } from 'docz';
import {
  Avatar,
  AvatarPlaceholder,
  BrandEspresso,
  BrandEspressoWeb,
  GraphicAudioChicago,
  GraphicAudioLondon,
  GraphicNewsletterChicago,
  GroupLogo,
  GroupLogoMasthead,
  GroupWordmark,
  IconCheck,
  IconCopy,
  Logo,
  MonogramCircle,
  MonogramSquare,
  SocialIconFacebook,
  SocialIconInstagram,
  SocialIconTwitter,
  SocialIconThreads,
  SocialIconTikTok,
  SocialIconLinkedIn,
  SocialIconYoutube,
  SocialIconRss,
  SocialIconWhatsApp,
  Wordmark,
  Wordmark1843,
  WorldAheadWordmark,
} from './assets.js';


const layoutProps = {
  
};
const MDXLayout = "wrapper"
export default function MDXContent({
  components,
  ...props
}) {
  return <MDXLayout {...layoutProps} {...props} components={components} mdxType="MDXLayout">

    <h1 {...{
      "id": "assets"
    }}>{`Assets`}</h1>
    <hr />
    <h2 {...{
      "id": "avatar"
    }}>{`Avatar`}</h2>
    <h3 {...{
      "id": "description"
    }}>{`Description`}</h3>
    <p>{`Use the white-on-red monogram for the primary brand and all sub-brands.
Use the secondary, red-on-white monogram for The Economist Group only.`}</p>
    <p><strong parentName="p">{`The Economist`}</strong></p>
    <Playground __position={1} __code={'<Avatar />'} __scope={{
      props: this ? this.props : props,
      Playground,
      Props,
      Avatar,
      AvatarPlaceholder,
      BrandEspresso,
      BrandEspressoWeb,
      GraphicAudioChicago,
      GraphicAudioLondon,
      GraphicNewsletterChicago,
      GroupLogo,
      GroupLogoMasthead,
      GroupWordmark,
      IconCheck,
      IconCopy,
      Logo,
      MonogramCircle,
      MonogramSquare,
      SocialIconFacebook,
      SocialIconInstagram,
      SocialIconTwitter,
      SocialIconThreads,
      SocialIconTikTok,
      SocialIconLinkedIn,
      SocialIconYoutube,
      SocialIconRss,
      SocialIconWhatsApp,
      Wordmark,
      Wordmark1843,
      WorldAheadWordmark
    }} mdxType="Playground">
  <Avatar mdxType="Avatar" />
    </Playground>
    <p><strong parentName="p">{`The Economist Group`}</strong></p>
    <Playground __position={2} __code={'<Avatar secondary />'} __scope={{
      props: this ? this.props : props,
      Playground,
      Props,
      Avatar,
      AvatarPlaceholder,
      BrandEspresso,
      BrandEspressoWeb,
      GraphicAudioChicago,
      GraphicAudioLondon,
      GraphicNewsletterChicago,
      GroupLogo,
      GroupLogoMasthead,
      GroupWordmark,
      IconCheck,
      IconCopy,
      Logo,
      MonogramCircle,
      MonogramSquare,
      SocialIconFacebook,
      SocialIconInstagram,
      SocialIconTwitter,
      SocialIconThreads,
      SocialIconTikTok,
      SocialIconLinkedIn,
      SocialIconYoutube,
      SocialIconRss,
      SocialIconWhatsApp,
      Wordmark,
      Wordmark1843,
      WorldAheadWordmark
    }} style={{
      display: 'flex',
      backgroundColor: '#e3120b',
      margin: '-2em',
      padding: '2em'
    }} mdxType="Playground">
  <Avatar secondary mdxType="Avatar" />
    </Playground>
    <p><strong parentName="p">{`Placeholder`}</strong></p>
    <Playground __position={3} __code={'<AvatarPlaceholder />'} __scope={{
      props: this ? this.props : props,
      Playground,
      Props,
      Avatar,
      AvatarPlaceholder,
      BrandEspresso,
      BrandEspressoWeb,
      GraphicAudioChicago,
      GraphicAudioLondon,
      GraphicNewsletterChicago,
      GroupLogo,
      GroupLogoMasthead,
      GroupWordmark,
      IconCheck,
      IconCopy,
      Logo,
      MonogramCircle,
      MonogramSquare,
      SocialIconFacebook,
      SocialIconInstagram,
      SocialIconTwitter,
      SocialIconThreads,
      SocialIconTikTok,
      SocialIconLinkedIn,
      SocialIconYoutube,
      SocialIconRss,
      SocialIconWhatsApp,
      Wordmark,
      Wordmark1843,
      WorldAheadWordmark
    }} mdxType="Playground">
  <AvatarPlaceholder mdxType="AvatarPlaceholder" />
    </Playground>
    <h2 {...{
      "id": "brands"
    }}>{`Brands`}</h2>
    <Playground __position={4} __code={'<BrandEspresso />\n<BrandEspressoWeb />'} __scope={{
      props: this ? this.props : props,
      Playground,
      Props,
      Avatar,
      AvatarPlaceholder,
      BrandEspresso,
      BrandEspressoWeb,
      GraphicAudioChicago,
      GraphicAudioLondon,
      GraphicNewsletterChicago,
      GroupLogo,
      GroupLogoMasthead,
      GroupWordmark,
      IconCheck,
      IconCopy,
      Logo,
      MonogramCircle,
      MonogramSquare,
      SocialIconFacebook,
      SocialIconInstagram,
      SocialIconTwitter,
      SocialIconThreads,
      SocialIconTikTok,
      SocialIconLinkedIn,
      SocialIconYoutube,
      SocialIconRss,
      SocialIconWhatsApp,
      Wordmark,
      Wordmark1843,
      WorldAheadWordmark
    }} mdxType="Playground">
  <BrandEspresso mdxType="BrandEspresso" />
  <BrandEspressoWeb mdxType="BrandEspressoWeb" />
    </Playground>
    <h2 {...{
      "id": "group-logo"
    }}>{`Group logo`}</h2>
    <h3 {...{
      "id": "description-1"
    }}>{`Description`}</h3>
    <p>{`The Economist Group master logo.`}</p>
    <Playground __position={5} __code={'<GroupLogo />'} __scope={{
      props: this ? this.props : props,
      Playground,
      Props,
      Avatar,
      AvatarPlaceholder,
      BrandEspresso,
      BrandEspressoWeb,
      GraphicAudioChicago,
      GraphicAudioLondon,
      GraphicNewsletterChicago,
      GroupLogo,
      GroupLogoMasthead,
      GroupWordmark,
      IconCheck,
      IconCopy,
      Logo,
      MonogramCircle,
      MonogramSquare,
      SocialIconFacebook,
      SocialIconInstagram,
      SocialIconTwitter,
      SocialIconThreads,
      SocialIconTikTok,
      SocialIconLinkedIn,
      SocialIconYoutube,
      SocialIconRss,
      SocialIconWhatsApp,
      Wordmark,
      Wordmark1843,
      WorldAheadWordmark
    }} mdxType="Playground">
  <GroupLogo mdxType="GroupLogo" />
    </Playground>
    <h2 {...{
      "id": "group-logo-masthead"
    }}>{`Group logo (masthead)`}</h2>
    <h3 {...{
      "id": "description-2"
    }}>{`Description`}</h3>
    <p>{`The Economist Group master logo for use with the masthead.`}</p>
    <Playground __position={6} __code={'<GroupLogoMasthead />'} __scope={{
      props: this ? this.props : props,
      Playground,
      Props,
      Avatar,
      AvatarPlaceholder,
      BrandEspresso,
      BrandEspressoWeb,
      GraphicAudioChicago,
      GraphicAudioLondon,
      GraphicNewsletterChicago,
      GroupLogo,
      GroupLogoMasthead,
      GroupWordmark,
      IconCheck,
      IconCopy,
      Logo,
      MonogramCircle,
      MonogramSquare,
      SocialIconFacebook,
      SocialIconInstagram,
      SocialIconTwitter,
      SocialIconThreads,
      SocialIconTikTok,
      SocialIconLinkedIn,
      SocialIconYoutube,
      SocialIconRss,
      SocialIconWhatsApp,
      Wordmark,
      Wordmark1843,
      WorldAheadWordmark
    }} mdxType="Playground">
  <GroupLogoMasthead mdxType="GroupLogoMasthead" />
    </Playground>
    <h2 {...{
      "id": "graphics"
    }}>{`Graphics`}</h2>
    <Playground __position={7} __code={'<GraphicAudioChicago />\n<GraphicAudioLondon />\n<GraphicNewsletterChicago />'} __scope={{
      props: this ? this.props : props,
      Playground,
      Props,
      Avatar,
      AvatarPlaceholder,
      BrandEspresso,
      BrandEspressoWeb,
      GraphicAudioChicago,
      GraphicAudioLondon,
      GraphicNewsletterChicago,
      GroupLogo,
      GroupLogoMasthead,
      GroupWordmark,
      IconCheck,
      IconCopy,
      Logo,
      MonogramCircle,
      MonogramSquare,
      SocialIconFacebook,
      SocialIconInstagram,
      SocialIconTwitter,
      SocialIconThreads,
      SocialIconTikTok,
      SocialIconLinkedIn,
      SocialIconYoutube,
      SocialIconRss,
      SocialIconWhatsApp,
      Wordmark,
      Wordmark1843,
      WorldAheadWordmark
    }} style={{
      display: 'flex',
      backgroundColor: '#ccc',
      margin: '-2em',
      padding: '2em'
    }} mdxType="Playground">
  <GraphicAudioChicago mdxType="GraphicAudioChicago" />
  <GraphicAudioLondon mdxType="GraphicAudioLondon" />
  <GraphicNewsletterChicago mdxType="GraphicNewsletterChicago" />
    </Playground>
    <h2 {...{
      "id": "group-wordmark"
    }}>{`Group wordmark`}</h2>
    <h3 {...{
      "id": "description-3"
    }}>{`Description`}</h3>
    <p>{`The Economist Group wordmark.`}</p>
    <Playground __position={8} __code={'<GroupWordmark />'} __scope={{
      props: this ? this.props : props,
      Playground,
      Props,
      Avatar,
      AvatarPlaceholder,
      BrandEspresso,
      BrandEspressoWeb,
      GraphicAudioChicago,
      GraphicAudioLondon,
      GraphicNewsletterChicago,
      GroupLogo,
      GroupLogoMasthead,
      GroupWordmark,
      IconCheck,
      IconCopy,
      Logo,
      MonogramCircle,
      MonogramSquare,
      SocialIconFacebook,
      SocialIconInstagram,
      SocialIconTwitter,
      SocialIconThreads,
      SocialIconTikTok,
      SocialIconLinkedIn,
      SocialIconYoutube,
      SocialIconRss,
      SocialIconWhatsApp,
      Wordmark,
      Wordmark1843,
      WorldAheadWordmark
    }} mdxType="Playground">
  <GroupWordmark mdxType="GroupWordmark" />
    </Playground>
    <h2 {...{
      "id": "logo"
    }}>{`Logo`}</h2>
    <h3 {...{
      "id": "description-4"
    }}>{`Description`}</h3>
    <p>{`The Economist master logo. At very small sizes where readability is compromised, consider using the monogram.`}</p>
    <Playground __position={9} __code={'<Logo />'} __scope={{
      props: this ? this.props : props,
      Playground,
      Props,
      Avatar,
      AvatarPlaceholder,
      BrandEspresso,
      BrandEspressoWeb,
      GraphicAudioChicago,
      GraphicAudioLondon,
      GraphicNewsletterChicago,
      GroupLogo,
      GroupLogoMasthead,
      GroupWordmark,
      IconCheck,
      IconCopy,
      Logo,
      MonogramCircle,
      MonogramSquare,
      SocialIconFacebook,
      SocialIconInstagram,
      SocialIconTwitter,
      SocialIconThreads,
      SocialIconTikTok,
      SocialIconLinkedIn,
      SocialIconYoutube,
      SocialIconRss,
      SocialIconWhatsApp,
      Wordmark,
      Wordmark1843,
      WorldAheadWordmark
    }} mdxType="Playground">
  <Logo mdxType="Logo" />
    </Playground>
    <hr />
    <h2 {...{
      "id": "monogram"
    }}>{`Monogram`}</h2>
    <h3 {...{
      "id": "description-5"
    }}>{`Description`}</h3>
    <p>{`The Economist monogram. For use in social media and app icons.`}</p>
    <p><strong parentName="p">{`Circle`}</strong></p>
    <Playground __position={11} __code={'<MonogramCircle />'} __scope={{
      props: this ? this.props : props,
      Playground,
      Props,
      Avatar,
      AvatarPlaceholder,
      BrandEspresso,
      BrandEspressoWeb,
      GraphicAudioChicago,
      GraphicAudioLondon,
      GraphicNewsletterChicago,
      GroupLogo,
      GroupLogoMasthead,
      GroupWordmark,
      IconCheck,
      IconCopy,
      Logo,
      MonogramCircle,
      MonogramSquare,
      SocialIconFacebook,
      SocialIconInstagram,
      SocialIconTwitter,
      SocialIconThreads,
      SocialIconTikTok,
      SocialIconLinkedIn,
      SocialIconYoutube,
      SocialIconRss,
      SocialIconWhatsApp,
      Wordmark,
      Wordmark1843,
      WorldAheadWordmark
    }} mdxType="Playground">
  <MonogramCircle mdxType="MonogramCircle" />
    </Playground>
    <p><strong parentName="p">{`Circle (inverse)`}</strong></p>
    <Playground __position={12} __code={'<MonogramCircle inverse />'} __scope={{
      props: this ? this.props : props,
      Playground,
      Props,
      Avatar,
      AvatarPlaceholder,
      BrandEspresso,
      BrandEspressoWeb,
      GraphicAudioChicago,
      GraphicAudioLondon,
      GraphicNewsletterChicago,
      GroupLogo,
      GroupLogoMasthead,
      GroupWordmark,
      IconCheck,
      IconCopy,
      Logo,
      MonogramCircle,
      MonogramSquare,
      SocialIconFacebook,
      SocialIconInstagram,
      SocialIconTwitter,
      SocialIconThreads,
      SocialIconTikTok,
      SocialIconLinkedIn,
      SocialIconYoutube,
      SocialIconRss,
      SocialIconWhatsApp,
      Wordmark,
      Wordmark1843,
      WorldAheadWordmark
    }} style={{
      display: 'flex',
      backgroundColor: '#e3120b',
      margin: '-2em',
      padding: '2em'
    }} mdxType="Playground">
  <MonogramCircle inverse mdxType="MonogramCircle" />
    </Playground>
    <p><strong parentName="p">{`Square`}</strong></p>
    <Playground __position={13} __code={'<MonogramSquare />'} __scope={{
      props: this ? this.props : props,
      Playground,
      Props,
      Avatar,
      AvatarPlaceholder,
      BrandEspresso,
      BrandEspressoWeb,
      GraphicAudioChicago,
      GraphicAudioLondon,
      GraphicNewsletterChicago,
      GroupLogo,
      GroupLogoMasthead,
      GroupWordmark,
      IconCheck,
      IconCopy,
      Logo,
      MonogramCircle,
      MonogramSquare,
      SocialIconFacebook,
      SocialIconInstagram,
      SocialIconTwitter,
      SocialIconThreads,
      SocialIconTikTok,
      SocialIconLinkedIn,
      SocialIconYoutube,
      SocialIconRss,
      SocialIconWhatsApp,
      Wordmark,
      Wordmark1843,
      WorldAheadWordmark
    }} mdxType="Playground">
  <MonogramSquare mdxType="MonogramSquare" />
    </Playground>
    <p><strong parentName="p">{`Square (inverse)`}</strong></p>
    <Playground __position={14} __code={'<MonogramSquare inverse />'} __scope={{
      props: this ? this.props : props,
      Playground,
      Props,
      Avatar,
      AvatarPlaceholder,
      BrandEspresso,
      BrandEspressoWeb,
      GraphicAudioChicago,
      GraphicAudioLondon,
      GraphicNewsletterChicago,
      GroupLogo,
      GroupLogoMasthead,
      GroupWordmark,
      IconCheck,
      IconCopy,
      Logo,
      MonogramCircle,
      MonogramSquare,
      SocialIconFacebook,
      SocialIconInstagram,
      SocialIconTwitter,
      SocialIconThreads,
      SocialIconTikTok,
      SocialIconLinkedIn,
      SocialIconYoutube,
      SocialIconRss,
      SocialIconWhatsApp,
      Wordmark,
      Wordmark1843,
      WorldAheadWordmark
    }} style={{
      display: 'flex',
      backgroundColor: '#e3120b',
      margin: '-2em',
      padding: '2em'
    }} mdxType="Playground">
  <MonogramSquare inverse mdxType="MonogramSquare" />
    </Playground>
    <hr />
    <h2 {...{
      "id": "icons"
    }}>{`Icons`}</h2>
    <p><strong parentName="p">{`Copy`}</strong></p>
    <Playground __position={16} __code={'<IconCopy />'} __scope={{
      props: this ? this.props : props,
      Playground,
      Props,
      Avatar,
      AvatarPlaceholder,
      BrandEspresso,
      BrandEspressoWeb,
      GraphicAudioChicago,
      GraphicAudioLondon,
      GraphicNewsletterChicago,
      GroupLogo,
      GroupLogoMasthead,
      GroupWordmark,
      IconCheck,
      IconCopy,
      Logo,
      MonogramCircle,
      MonogramSquare,
      SocialIconFacebook,
      SocialIconInstagram,
      SocialIconTwitter,
      SocialIconThreads,
      SocialIconTikTok,
      SocialIconLinkedIn,
      SocialIconYoutube,
      SocialIconRss,
      SocialIconWhatsApp,
      Wordmark,
      Wordmark1843,
      WorldAheadWordmark
    }} mdxType="Playground">
  <IconCopy mdxType="IconCopy" />
    </Playground>
    <p><strong parentName="p">{`Check`}</strong></p>
    <Playground __position={17} __code={'<IconCheck />'} __scope={{
      props: this ? this.props : props,
      Playground,
      Props,
      Avatar,
      AvatarPlaceholder,
      BrandEspresso,
      BrandEspressoWeb,
      GraphicAudioChicago,
      GraphicAudioLondon,
      GraphicNewsletterChicago,
      GroupLogo,
      GroupLogoMasthead,
      GroupWordmark,
      IconCheck,
      IconCopy,
      Logo,
      MonogramCircle,
      MonogramSquare,
      SocialIconFacebook,
      SocialIconInstagram,
      SocialIconTwitter,
      SocialIconThreads,
      SocialIconTikTok,
      SocialIconLinkedIn,
      SocialIconYoutube,
      SocialIconRss,
      SocialIconWhatsApp,
      Wordmark,
      Wordmark1843,
      WorldAheadWordmark
    }} mdxType="Playground">
  <IconCheck mdxType="IconCheck" />
    </Playground>
    <hr />
    <h2 {...{
      "id": "social-icons"
    }}>{`Social Icons`}</h2>
    <p><strong parentName="p">{`Facebook`}</strong></p>
    <Playground __position={19} __code={'<SocialIconFacebook />'} __scope={{
      props: this ? this.props : props,
      Playground,
      Props,
      Avatar,
      AvatarPlaceholder,
      BrandEspresso,
      BrandEspressoWeb,
      GraphicAudioChicago,
      GraphicAudioLondon,
      GraphicNewsletterChicago,
      GroupLogo,
      GroupLogoMasthead,
      GroupWordmark,
      IconCheck,
      IconCopy,
      Logo,
      MonogramCircle,
      MonogramSquare,
      SocialIconFacebook,
      SocialIconInstagram,
      SocialIconTwitter,
      SocialIconThreads,
      SocialIconTikTok,
      SocialIconLinkedIn,
      SocialIconYoutube,
      SocialIconRss,
      SocialIconWhatsApp,
      Wordmark,
      Wordmark1843,
      WorldAheadWordmark
    }} mdxType="Playground">
  <SocialIconFacebook mdxType="SocialIconFacebook" />
    </Playground>
    <p><strong parentName="p">{`Instagram`}</strong></p>
    <Playground __position={20} __code={'<SocialIconInstagram />'} __scope={{
      props: this ? this.props : props,
      Playground,
      Props,
      Avatar,
      AvatarPlaceholder,
      BrandEspresso,
      BrandEspressoWeb,
      GraphicAudioChicago,
      GraphicAudioLondon,
      GraphicNewsletterChicago,
      GroupLogo,
      GroupLogoMasthead,
      GroupWordmark,
      IconCheck,
      IconCopy,
      Logo,
      MonogramCircle,
      MonogramSquare,
      SocialIconFacebook,
      SocialIconInstagram,
      SocialIconTwitter,
      SocialIconThreads,
      SocialIconTikTok,
      SocialIconLinkedIn,
      SocialIconYoutube,
      SocialIconRss,
      SocialIconWhatsApp,
      Wordmark,
      Wordmark1843,
      WorldAheadWordmark
    }} mdxType="Playground">
  <SocialIconInstagram mdxType="SocialIconInstagram" />
    </Playground>
    <p><strong parentName="p">{`LinkedIn`}</strong></p>
    <Playground __position={21} __code={'<SocialIconLinkedIn />'} __scope={{
      props: this ? this.props : props,
      Playground,
      Props,
      Avatar,
      AvatarPlaceholder,
      BrandEspresso,
      BrandEspressoWeb,
      GraphicAudioChicago,
      GraphicAudioLondon,
      GraphicNewsletterChicago,
      GroupLogo,
      GroupLogoMasthead,
      GroupWordmark,
      IconCheck,
      IconCopy,
      Logo,
      MonogramCircle,
      MonogramSquare,
      SocialIconFacebook,
      SocialIconInstagram,
      SocialIconTwitter,
      SocialIconThreads,
      SocialIconTikTok,
      SocialIconLinkedIn,
      SocialIconYoutube,
      SocialIconRss,
      SocialIconWhatsApp,
      Wordmark,
      Wordmark1843,
      WorldAheadWordmark
    }} mdxType="Playground">
  <SocialIconLinkedIn mdxType="SocialIconLinkedIn" />
    </Playground>
    <p><strong parentName="p">{`RSS`}</strong></p>
    <Playground __position={22} __code={'<SocialIconRss />'} __scope={{
      props: this ? this.props : props,
      Playground,
      Props,
      Avatar,
      AvatarPlaceholder,
      BrandEspresso,
      BrandEspressoWeb,
      GraphicAudioChicago,
      GraphicAudioLondon,
      GraphicNewsletterChicago,
      GroupLogo,
      GroupLogoMasthead,
      GroupWordmark,
      IconCheck,
      IconCopy,
      Logo,
      MonogramCircle,
      MonogramSquare,
      SocialIconFacebook,
      SocialIconInstagram,
      SocialIconTwitter,
      SocialIconThreads,
      SocialIconTikTok,
      SocialIconLinkedIn,
      SocialIconYoutube,
      SocialIconRss,
      SocialIconWhatsApp,
      Wordmark,
      Wordmark1843,
      WorldAheadWordmark
    }} mdxType="Playground">
  <SocialIconRss mdxType="SocialIconRss" />
    </Playground>
    <p><strong parentName="p">{`X (Twitter)`}</strong></p>
    <Playground __position={23} __code={'<SocialIconTwitter />'} __scope={{
      props: this ? this.props : props,
      Playground,
      Props,
      Avatar,
      AvatarPlaceholder,
      BrandEspresso,
      BrandEspressoWeb,
      GraphicAudioChicago,
      GraphicAudioLondon,
      GraphicNewsletterChicago,
      GroupLogo,
      GroupLogoMasthead,
      GroupWordmark,
      IconCheck,
      IconCopy,
      Logo,
      MonogramCircle,
      MonogramSquare,
      SocialIconFacebook,
      SocialIconInstagram,
      SocialIconTwitter,
      SocialIconThreads,
      SocialIconTikTok,
      SocialIconLinkedIn,
      SocialIconYoutube,
      SocialIconRss,
      SocialIconWhatsApp,
      Wordmark,
      Wordmark1843,
      WorldAheadWordmark
    }} mdxType="Playground">
  <SocialIconTwitter mdxType="SocialIconTwitter" />
    </Playground>
    <p><strong parentName="p">{`TikTok`}</strong></p>
    <Playground __position={24} __code={'<SocialIconTikTok />'} __scope={{
      props: this ? this.props : props,
      Playground,
      Props,
      Avatar,
      AvatarPlaceholder,
      BrandEspresso,
      BrandEspressoWeb,
      GraphicAudioChicago,
      GraphicAudioLondon,
      GraphicNewsletterChicago,
      GroupLogo,
      GroupLogoMasthead,
      GroupWordmark,
      IconCheck,
      IconCopy,
      Logo,
      MonogramCircle,
      MonogramSquare,
      SocialIconFacebook,
      SocialIconInstagram,
      SocialIconTwitter,
      SocialIconThreads,
      SocialIconTikTok,
      SocialIconLinkedIn,
      SocialIconYoutube,
      SocialIconRss,
      SocialIconWhatsApp,
      Wordmark,
      Wordmark1843,
      WorldAheadWordmark
    }} mdxType="Playground">
  <SocialIconTikTok mdxType="SocialIconTikTok" />
    </Playground>
    <p><strong parentName="p">{`Threads`}</strong></p>
    <Playground __position={25} __code={'<SocialIconThreads />'} __scope={{
      props: this ? this.props : props,
      Playground,
      Props,
      Avatar,
      AvatarPlaceholder,
      BrandEspresso,
      BrandEspressoWeb,
      GraphicAudioChicago,
      GraphicAudioLondon,
      GraphicNewsletterChicago,
      GroupLogo,
      GroupLogoMasthead,
      GroupWordmark,
      IconCheck,
      IconCopy,
      Logo,
      MonogramCircle,
      MonogramSquare,
      SocialIconFacebook,
      SocialIconInstagram,
      SocialIconTwitter,
      SocialIconThreads,
      SocialIconTikTok,
      SocialIconLinkedIn,
      SocialIconYoutube,
      SocialIconRss,
      SocialIconWhatsApp,
      Wordmark,
      Wordmark1843,
      WorldAheadWordmark
    }} mdxType="Playground">
  <SocialIconThreads mdxType="SocialIconThreads" />
    </Playground>
    <p><strong parentName="p">{`WhatsApp`}</strong></p>
    <Playground __position={26} __code={'<SocialIconWhatsApp />'} __scope={{
      props: this ? this.props : props,
      Playground,
      Props,
      Avatar,
      AvatarPlaceholder,
      BrandEspresso,
      BrandEspressoWeb,
      GraphicAudioChicago,
      GraphicAudioLondon,
      GraphicNewsletterChicago,
      GroupLogo,
      GroupLogoMasthead,
      GroupWordmark,
      IconCheck,
      IconCopy,
      Logo,
      MonogramCircle,
      MonogramSquare,
      SocialIconFacebook,
      SocialIconInstagram,
      SocialIconTwitter,
      SocialIconThreads,
      SocialIconTikTok,
      SocialIconLinkedIn,
      SocialIconYoutube,
      SocialIconRss,
      SocialIconWhatsApp,
      Wordmark,
      Wordmark1843,
      WorldAheadWordmark
    }} mdxType="Playground">
  <SocialIconWhatsApp mdxType="SocialIconWhatsApp" />
    </Playground>
    <p><strong parentName="p">{`YouTube`}</strong></p>
    <Playground __position={27} __code={'<SocialIconYoutube />'} __scope={{
      props: this ? this.props : props,
      Playground,
      Props,
      Avatar,
      AvatarPlaceholder,
      BrandEspresso,
      BrandEspressoWeb,
      GraphicAudioChicago,
      GraphicAudioLondon,
      GraphicNewsletterChicago,
      GroupLogo,
      GroupLogoMasthead,
      GroupWordmark,
      IconCheck,
      IconCopy,
      Logo,
      MonogramCircle,
      MonogramSquare,
      SocialIconFacebook,
      SocialIconInstagram,
      SocialIconTwitter,
      SocialIconThreads,
      SocialIconTikTok,
      SocialIconLinkedIn,
      SocialIconYoutube,
      SocialIconRss,
      SocialIconWhatsApp,
      Wordmark,
      Wordmark1843,
      WorldAheadWordmark
    }} mdxType="Playground">
  <SocialIconYoutube mdxType="SocialIconYoutube" />
    </Playground>
    <h2 {...{
      "id": "wordmark"
    }}>{`Wordmark`}</h2>
    <h3 {...{
      "id": "description-6"
    }}>{`Description`}</h3>
    <p>{`For exceptional cases where it would be difficult to use the master logo, or specific product
journeys outside of the primary customer experience.`}</p>
    <Playground __position={28} __code={'<Wordmark />'} __scope={{
      props: this ? this.props : props,
      Playground,
      Props,
      Avatar,
      AvatarPlaceholder,
      BrandEspresso,
      BrandEspressoWeb,
      GraphicAudioChicago,
      GraphicAudioLondon,
      GraphicNewsletterChicago,
      GroupLogo,
      GroupLogoMasthead,
      GroupWordmark,
      IconCheck,
      IconCopy,
      Logo,
      MonogramCircle,
      MonogramSquare,
      SocialIconFacebook,
      SocialIconInstagram,
      SocialIconTwitter,
      SocialIconThreads,
      SocialIconTikTok,
      SocialIconLinkedIn,
      SocialIconYoutube,
      SocialIconRss,
      SocialIconWhatsApp,
      Wordmark,
      Wordmark1843,
      WorldAheadWordmark
    }} mdxType="Playground">
  <Wordmark mdxType="Wordmark" />
    </Playground>
    <h2 {...{
      "id": "wordmark-inverse"
    }}>{`Wordmark (inverse)`}</h2>
    <h3 {...{
      "id": "description-7"
    }}>{`Description`}</h3>
    <p>{`The Economist master logo. Use only on a red background.`}</p>
    <Playground __position={29} __code={'<Wordmark inverse />'} __scope={{
      props: this ? this.props : props,
      Playground,
      Props,
      Avatar,
      AvatarPlaceholder,
      BrandEspresso,
      BrandEspressoWeb,
      GraphicAudioChicago,
      GraphicAudioLondon,
      GraphicNewsletterChicago,
      GroupLogo,
      GroupLogoMasthead,
      GroupWordmark,
      IconCheck,
      IconCopy,
      Logo,
      MonogramCircle,
      MonogramSquare,
      SocialIconFacebook,
      SocialIconInstagram,
      SocialIconTwitter,
      SocialIconThreads,
      SocialIconTikTok,
      SocialIconLinkedIn,
      SocialIconYoutube,
      SocialIconRss,
      SocialIconWhatsApp,
      Wordmark,
      Wordmark1843,
      WorldAheadWordmark
    }} style={{
      display: 'flex',
      backgroundColor: '#e3120b',
      margin: '-2em',
      padding: '2em'
    }} mdxType="Playground">
  <Wordmark inverse mdxType="Wordmark" />
    </Playground>
    <p><strong parentName="p">{`Wordmark1843`}</strong></p>
    <Playground __position={30} __code={'<Wordmark1843 />'} __scope={{
      props: this ? this.props : props,
      Playground,
      Props,
      Avatar,
      AvatarPlaceholder,
      BrandEspresso,
      BrandEspressoWeb,
      GraphicAudioChicago,
      GraphicAudioLondon,
      GraphicNewsletterChicago,
      GroupLogo,
      GroupLogoMasthead,
      GroupWordmark,
      IconCheck,
      IconCopy,
      Logo,
      MonogramCircle,
      MonogramSquare,
      SocialIconFacebook,
      SocialIconInstagram,
      SocialIconTwitter,
      SocialIconThreads,
      SocialIconTikTok,
      SocialIconLinkedIn,
      SocialIconYoutube,
      SocialIconRss,
      SocialIconWhatsApp,
      Wordmark,
      Wordmark1843,
      WorldAheadWordmark
    }} mdxType="Playground">
  <Wordmark1843 mdxType="Wordmark1843" />
    </Playground>
    <p><strong parentName="p">{`WorldAheadWordmark`}</strong></p>
    <Playground __position={31} __code={'<WorldAheadWordmark />'} __scope={{
      props: this ? this.props : props,
      Playground,
      Props,
      Avatar,
      AvatarPlaceholder,
      BrandEspresso,
      BrandEspressoWeb,
      GraphicAudioChicago,
      GraphicAudioLondon,
      GraphicNewsletterChicago,
      GroupLogo,
      GroupLogoMasthead,
      GroupWordmark,
      IconCheck,
      IconCopy,
      Logo,
      MonogramCircle,
      MonogramSquare,
      SocialIconFacebook,
      SocialIconInstagram,
      SocialIconTwitter,
      SocialIconThreads,
      SocialIconTikTok,
      SocialIconLinkedIn,
      SocialIconYoutube,
      SocialIconRss,
      SocialIconWhatsApp,
      Wordmark,
      Wordmark1843,
      WorldAheadWordmark
    }} mdxType="Playground">
  <WorldAheadWordmark mdxType="WorldAheadWordmark" />
    </Playground>
    </MDXLayout>;
}

;
MDXContent.isMDXComponent = true;